/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

import colors from "assets/theme/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";

const { transparent, text, outline, surface, info, secondary, warning } = colors;

const iconSize = (px) => ({
  "& .material-icons, & .material-icons-round, & svg": {
    fontSize: pxToRem(px),
  },
});

const outlined = {
  base: {
    minHeight: pxToRem(40),
    color: text.main,
    borderColor: outline.variant,
    backgroundColor: transparent.main,
    padding: `0 ${pxToRem(20)}`,
    "&:hover": {
      backgroundColor: surface.container,
      borderColor: outline.main,
    },
    ...iconSize(18),
  },

  small: {
    minHeight: pxToRem(32),
    padding: `0 ${pxToRem(14)}`,
    fontSize: pxToRem(12),
    ...iconSize(16),
  },

  large: {
    minHeight: pxToRem(48),
    padding: `0 ${pxToRem(24)}`,
    fontSize: pxToRem(14),
    ...iconSize(20),
  },

  primary: {
    backgroundColor: transparent.main,
    borderColor: info.main,
    "&:hover": {
      backgroundColor: surface.container,
      borderColor: info.main,
    },
  },

  secondary: {
    backgroundColor: transparent.main,
    borderColor: secondary.main,
    "&:hover": {
      backgroundColor: surface.container,
      borderColor: secondary.main,
    },
  },

  warning: {
    backgroundColor: transparent.main,
    borderColor: warning.main,
    "&:hover": {
      backgroundColor: surface.container,
      borderColor: warning.main,
    },
  },
};

export default outlined;
